var cifCd = ["301 225", "<g fill='none'><path fill='#007FFF' d='M.5 0h300v225H.5z'/><path fill='#F7D618' d='M14 45h31.5l9.75-31.5L65 45h31.5L71 64.5 80.75 96l-25.5-19.5L29.75 96l9.75-31.5L14 45zM281.75 0L.5 168.75V225h18.75L300.5 56.25V0h-18.75z'/><path fill='#CE1021' d='M300.5 0L.5 180v45l300-180V0'/></g>"];

export { cifCd };

